import { api } from "@/lib/apiClient";
import type { GroSettings, GroSettingsUpdateIn } from "@/types/gro";

export async function getGroSettings() {
  return api.get<GroSettings>("/gro/settings");
}

export async function updateGroSettings(payload: GroSettingsUpdateIn) {
  return api.put<GroSettings>("/gro/settings", payload);
}
